import { render, staticRenderFns } from "./KT-Photo.vue?vue&type=template&id=4268e558&scoped=true&lang=pug&"
import script from "./KT-Photo.vue?vue&type=script&lang=js&"
export * from "./KT-Photo.vue?vue&type=script&lang=js&"
import style0 from "./KT-Photo.vue?vue&type=style&index=0&id=4268e558&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4268e558",
  null
  
)

export default component.exports